import Vue from 'vue'
import Vuex from 'vuex'

import PanoramasStore from './PanoramasStore'
import IsPcStore from './IsPcStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    setting: {
      home: {
        middleList: [
          {
            id: 'history',
            name: '御窑历史'
          }
        ]
      }
    }
  },
  modules: {
    PanoramasStore,
    IsPcStore
  }
})
